import { container } from "tsyringe";
import "reflect-metadata";
import { ItemsClient } from "./itemsClient";

export class ItemsService {
	private readonly itemsClient: ItemsClient = container.resolve(ItemsClient);

	async getItems() {
		return this.itemsClient.itemsApi.itemsControllerGetSalesItems();
	}

	//TODO: API for Fast Access Items / Fast Second
}
